<template>
  <div>
    <!-- 定制片CT/DIA输入弹窗 -->
    <el-dialog title="定制片信息 - 请填写" :visible.sync="dialogVisible" center :close-on-click-modal="false" :append-to-body="true" width="650px">
      <div v-for="(item, idx) in customItems" :key="idx" style="margin-bottom: 20px;">
        <div style="font-weight: bold; margin-bottom: 8px;">{{ item['商品名称'] }}</div>
        <el-table :data="getCustomRows(idx)" border size="small" style="width: 100%;">
          <el-table-column label="球镜" width="100">
            <template slot-scope="scope">{{ scope.row.sphere }}</template>
          </el-table-column>
          <el-table-column label="柱镜" width="100">
            <template slot-scope="scope">{{ scope.row.cylinder }}</template>
          </el-table-column>
          <el-table-column label="中心厚度">
            <template slot-scope="scope">
              <el-input v-model="customInputs[idx][scope.$index].ct" placeholder="必填" size="small"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="直径">
            <template slot-scope="scope">
              <el-input v-model="customInputs[idx][scope.$index].dia" placeholder="必填" size="small"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="数量" width="80" align="center">
            <template slot-scope="scope">
              <el-input-number v-model="customInputs[idx][scope.$index].qty" :min="1" :precision="0" size="small" :controls="false" style="width: 70px;"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80">
            <template slot-scope="scope">
              <el-button type="primary" size="small" @click="printCustomRow(idx, scope.$index)">打印</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button type="primary" @click="confirmAndPrint">确定打印</el-button>
      </div>
    </el-dialog>
    <!-- 单片标签选择弹窗：光度选择行（多行，每行选球镜/柱镜） -->
    <el-dialog title="单片标签打印 - 请选择光度" :visible.sync="singleDialogVisible" center :close-on-click-modal="false" :append-to-body="true" width="700px">
      <div v-for="(row, idx) in singleRows" :key="idx" style="display: flex; align-items: center; margin-bottom: 12px; border: 1px solid #ebeef5; border-radius: 4px; padding: 10px;">
        <el-select v-if="singleProducts.length > 1" v-model="row.productCode" filterable placeholder="商品" style="width: 150px;" @change="onProductChange(idx)">
          <el-option v-for="p in singleProducts" :key="p" :label="getProductLabel(p)" :value="p"></el-option>
        </el-select>
        <el-select v-model="row.sphere" filterable placeholder="球镜" style="width: 150px;" @change="onSphereChange(row, idx)">
          <el-option v-for="s in getSphereOptions(idx)" :key="s" :label="s" :value="s"></el-option>
        </el-select>
        <el-select v-model="row.cylinder" filterable placeholder="柱镜" style="width: 150px; margin-left: 8px;" @change="onCylinderChange(idx)">
          <el-option v-for="c in getCylinderOptions(idx)" :key="c" :label="c" :value="c"></el-option>
        </el-select>
        <el-select v-if="hasVerifyCode && row.verifyCodes && row.verifyCodes.length > 0" v-model="row.verifyCode" filterable placeholder="防伪码" style="width: 260px; margin-left: 8px;">
          <el-option v-for="vc in row.verifyCodes" :key="vc" :label="vc" :value="vc"></el-option>
        </el-select>
        <el-input-number v-if="!hasVerifyCode" v-model="row.qty" :min="1" :precision="0" size="small" :controls="false" style="width: 90px; margin-left: 8px;" placeholder="数量"></el-input-number>
        <el-button type="primary" size="small" style="margin-left: 12px;" @click="printRow(row)">打印</el-button>
        <el-button type="danger" size="small" icon="el-icon-delete" style="margin-left: 6px;" v-if="singleRows.length > 1" @click="removeRow(idx)"></el-button>
      </div>
      <div style="text-align: center;">
        <el-button type="text" icon="el-icon-plus" @click="addRow">新增一行</el-button>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="singleDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="printAll">开始打印</el-button>
      </div>
    </el-dialog>
    <!-- 打印区域 -->
    <div ref="printArea" v-if="isprint" style="width: 100%; margin: 0 auto;">
      <div v-for="(item, idx) in printdata" :key="idx">
        <div v-for="page in getPageCount(item)" :key="page"
             :style="pageStyle(item)"
             style="position: relative; overflow: hidden; box-sizing: border-box;">
          <div v-for="comp in getComponents(item)" :key="comp.id"
               :style="getCompStyle(comp, item)">
            <span v-if="comp.type === 'text'"
                  :style="{fontSize: getFontSizePx(comp, item) + 'px', whiteSpace: 'nowrap'}">{{ comp.content }}</span>
            <span v-else-if="comp.type === 'field'"
                  :style="{fontSize: getFontSizePx(comp, item) + 'px', whiteSpace: 'nowrap'}">{{ getFieldValue(comp.fieldName, item) }}</span>
            <svg v-else-if="comp.type === 'barcode'" :ref="'barcode_' + idx + '_' + page + '_' + comp.id"
                 style="width: 100%; height: 100%;"></svg>
            <img v-else-if="comp.type === 'qrcode' && getQrCodeSrc(comp, item)"
                 :src="getQrCodeSrc(comp, item)"
                 style="width: 100%; height: 100%; object-fit: contain; border: none;" />
            <img v-else-if="comp.type === 'image' && getImageUrl(comp, item)"
                 :src="getImageUrl(comp, item)"
                 style="width: 100%; height: 100%; object-fit: contain; border: none;" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import JsBarcode from 'jsbarcode'
import { saveLabelPrintLog } from '@/api/set/csagreement'

export default {
  name: 'LensLabelPrint',
  data() {
    return {
      printdata: [],
      isprint: false,
      labelType: '',
      dialogVisible: false,
      customItems: [],
      customInputs: [],
      _fullData: [],
      //单片打印
      singleDialogVisible: false,
      singleRows: [],
      singleSpheres: [],
      singleCylinders: [],
      singleProducts: [],
      hasVerifyCode: false
    }
  },
  methods: {
    //单片打印：拉全量后弹出选择页
    printSingle(data, labelType) {
      this.labelType = labelType || ''
      this._fullData = data || []
      // 检查是否有防伪码地址
      this.hasVerifyCode = false
      this._fullData.forEach(item => {
        if (item['防伪码地址']) {
          this.hasVerifyCode = true
        }
      })
      //提取商品编码（去重，保持顺序）
      const products = []
      this._fullData.forEach(item => {
        const code = item['商品编码']
        if (code !== undefined && code !== null && code !== '' && products.indexOf(String(code)) === -1) {
          products.push(String(code))
        }
      })
      this.singleProducts = products
      //提取订单光度范围（球镜/柱镜 去重）
      const spheres = []
      const cylinders = []
      this._fullData.forEach(item => {
        const sp = item['球镜']
        const cy = item['柱镜']
        if (sp !== undefined && sp !== null && sp !== '' && spheres.indexOf(String(sp)) === -1) spheres.push(String(sp))
        if (cy !== undefined && cy !== null && cy !== '' && cylinders.indexOf(String(cy)) === -1) cylinders.push(String(cy))
      })
      this.singleSpheres = spheres
      this.singleCylinders = cylinders
      //默认一行；只有一个商品时自动选中
      const defaultProduct = products.length === 1 ? products[0] : ''
      this.singleRows = [{productCode: defaultProduct, sphere: '', cylinder: '', qty: 1, verifyCode: '', verifyCodes: []}]
      this.singleDialogVisible = true
    },
    //按当前行选的商品过滤数据
    getRowFilteredData(row) {
      if (!row || !row.productCode) return this._fullData
      return this._fullData.filter(item => String(item['商品编码']) === String(row.productCode))
    },
    //获取商品显示名（商品编码 + 商品名称）
    getProductLabel(code) {
      const item = this._fullData.find(it => String(it['商品编码']) === String(code))
      if (item && item['商品名称']) return item['商品名称']
      return code
    },
    //选商品：清空球镜/柱镜/防伪码
    onProductChange(idx) {
      const row = this.singleRows[idx]
      if (!row) return
      row.sphere = ''
      row.cylinder = ''
      row.verifyCode = ''
      row.verifyCodes = []
    },
    //球镜选项：按当前行选的商品过滤
    getSphereOptions(idx) {
      const row = this.singleRows[idx]
      const data = this.getRowFilteredData(row)
      const opts = []
      data.forEach(item => {
        const sp = item['球镜']
        if (sp !== undefined && sp !== null && sp !== '' && opts.indexOf(String(sp)) === -1) opts.push(String(sp))
      })
      return opts
    },
    //柱镜选项：选球镜后按当前行商品+球镜过滤
    getCylinderOptions(idx) {
      const row = this.singleRows[idx]
      if (!row) return this.singleCylinders
      if (!row.sphere) {
        const data = this.getRowFilteredData(row)
        const opts = []
        data.forEach(item => {
          const cy = item['柱镜']
          if (cy !== undefined && cy !== null && cy !== '' && opts.indexOf(String(cy)) === -1) opts.push(String(cy))
        })
        return opts
      }
      const data = this.getRowFilteredData(row)
      const opts = []
      data.forEach(item => {
        if (String(item['球镜']) === String(row.sphere)) {
          const cy = item['柱镜']
          if (cy !== undefined && cy !== null && cy !== '' && opts.indexOf(String(cy)) === -1) opts.push(String(cy))
        }
      })
      return opts
    },
    //选球镜：清空柱镜和防伪码；过滤后唯一自动选上；更新防伪码列表
    onSphereChange(row, idx) {
      row.cylinder = ''
      row.verifyCode = ''
      row.verifyCodes = []
      // 更新防伪码列表
      if (this.hasVerifyCode) {
        this.updateVerifyCodesForRow(idx)
      }
      const opts = this.getCylinderOptions(idx)
      if (opts.length === 1) row.cylinder = opts[0]
    },
    //选柱镜：更新防伪码列表
    onCylinderChange(idx) {
      if (this.hasVerifyCode) {
        const row = this.singleRows[idx]
        row.verifyCode = ''
        this.updateVerifyCodesForRow(idx)
      }
    },
    //根据球镜/柱镜更新防伪码列表
    updateVerifyCodesForRow(idx) {
      const row = this.singleRows[idx]
      if (!row) return
      const codes = new Set()
      const data = this.getRowFilteredData(row)
      data.forEach(item => {
        const sp = String(item['球镜'] == null ? '' : item['球镜'])
        const cy = String(item['柱镜'] == null ? '' : item['柱镜'])
        if (row.sphere && sp !== String(row.sphere)) return
        if (row.cylinder && cy !== String(row.cylinder)) return
        const addr = item['防伪码地址']
        if (addr) {
          // 从地址中提取sn参数
          const match = addr.match(/sn=([^&]+)/)
          if (match) codes.add(match[1])
        }
      })
      row.verifyCodes = Array.from(codes)
      // 球镜+柱镜都选好后，只剩一个防伪码则自动选上
      if (row.verifyCodes.length === 1 && row.sphere && row.cylinder) {
        row.verifyCode = row.verifyCodes[0]
      }
    },
    addRow() {
      const defaultProduct = this.singleProducts.length === 1 ? this.singleProducts[0] : ''
      this.singleRows.push({productCode: defaultProduct, sphere: '', cylinder: '', qty: 1, verifyCode: '', verifyCodes: []})
    },
    removeRow(idx) {
      this.singleRows.splice(idx, 1)
    },
    //按行的商品编码/球镜/柱镜/防伪码过滤全量数据
    filterByRow(row) {
      const result = []
      const qty = this.hasVerifyCode ? 1 : (parseInt(row.qty) || 1)
      const data = this.getRowFilteredData(row)
      data.forEach(item => {
        const sp = String(item['球镜'] == null ? '' : item['球镜'])
        const cy = String(item['柱镜'] == null ? '' : item['柱镜'])
        if (row.sphere && sp !== String(row.sphere)) return
        if (row.cylinder && cy !== String(row.cylinder)) return
        // 如果有防伪码，还需要匹配防伪码
        if (this.hasVerifyCode && row.verifyCode) {
          const addr = item['防伪码地址']
          if (!addr) return
          const match = addr.match(/sn=([^&]+)/)
          if (!match || match[1] !== row.verifyCode) return
        }
        const copy = Object.assign({}, item)
        copy['number'] = qty
        result.push(copy)
      })
      return result
    },
    //行内打印（单片）
    printRow(row) {
      if (!row.sphere) {
        this.$message.warning('请选择球镜')
        return
      }
      if (this.hasVerifyCode && !row.verifyCode) {
        this.$message.warning('请选择防伪码')
        return
      }
      const filtered = this.filterByRow(row)
      if (filtered.length === 0) {
        this.$message.warning('该光度没有对应的标签数据')
        return
      }
      this.doCustomPrint(filtered)
    },
    //全部打印（开始打印）
    printAll() {
      let filtered = []
      this.singleRows.forEach(row => {
        if (!row.sphere) return
        if (this.hasVerifyCode && !row.verifyCode) return
        filtered = filtered.concat(this.filterByRow(row))
      })
      if (filtered.length === 0) {
        this.$message.warning(this.hasVerifyCode ? '请先选择球镜和防伪码' : '请先选择球镜')
        return
      }
      this.doCustomPrint(filtered)
    },
    //打印前处理定制片CT/DIA（复用现有custom弹窗逻辑）
    doCustomPrint(data) {
      this._fullData = data || []
      const customs = this._fullData.filter(item => item.isCustom === true)
      if (customs.length > 0) {
        this.customItems = customs
        this.customInputs = []
        customs.forEach((item, i) => {
          const num = parseInt(item['number']) || 1
          const rows = []
          for (let j = 0; j < num; j++) {
            rows.push({
              ct: item['中心厚度'] || '',
              dia: item['直径'] || '',
              qty: 1
            })
          }
          this.customInputs.push(rows)
        })
        this.dialogVisible = true
      } else {
        this.doPrint(this._fullData)
      }
    },
    print(data, labelType) {
      this.labelType = labelType || ''
      this._fullData = data || []
      // 检查是否有定制片需要用户输入
      const customs = this._fullData.filter(item => item.isCustom === true)
      if (customs.length > 0) {
        this.customItems = customs
        this.customInputs = []
        customs.forEach((item, i) => {
          const num = parseInt(item['number']) || 1
          const rows = []
          for (let j = 0; j < num; j++) {
            rows.push({
              ct: item['中心厚度'] || '',
              dia: item['直径'] || '',
              qty: 1
            })
          }
          this.customInputs.push(rows)
        })
        this.dialogVisible = true
      } else {
        this.doPrint(this._fullData)
      }
    },
    getCustomRows(idx) {
      const item = this.customItems[idx]
      const num = parseInt(item['number']) || 1
      const rows = []
      for (let i = 0; i < num; i++) {
        rows.push({
          sphere: item['球镜'] || '',
          cylinder: item['柱镜'] || ''
        })
      }
      return rows
    },
    confirmAndPrint() {
      // 校验必填
      let hasEmpty = false
      this.customInputs.forEach(rows => {
        rows.forEach(row => {
          if (!row.ct || !row.dia) hasEmpty = true
        })
      })
      if (hasEmpty) {
        this.$message.warning('请填写所有中心厚度和直径')
        return
      }

      // 展开定制片数据
      const expandedData = []
      const remarkList = []
      let customIdx = 0
      this._fullData.forEach(item => {
        if (item.isCustom === true) {
          const inputs = this.customInputs[customIdx++]
          if (inputs) {
            inputs.forEach(row => {
              const copy = Object.assign({}, item)
              copy['中心厚度'] = row.ct
              copy['直径'] = row.dia
              copy['number'] = 1
              expandedData.push(copy)
              remarkList.push({
                seedcode: copy['商品编码'],
                packagesize: copy['_packagesize'] || '',
                ct: row.ct,
                dia: row.dia
              })
            })
          }
        } else {
          expandedData.push(item)
        }
      })

      // 保存到打印日志
      saveLabelPrintLog({
        erpserial: this.customItems[0]['订单编号'],
        labelType: this.labelType,
        remark: JSON.stringify(remarkList)
      }).catch(() => {})

      this.dialogVisible = false
      this.doPrint(expandedData)
    },
    //定制片表格行打印：只打印当前行这一片（需已填该行的中心厚度/直径），数量可填默认1
    printCustomRow(idx, rowIndex) {
      const item = this.customItems[idx]
      const input = this.customInputs[idx] && this.customInputs[idx][rowIndex]
      if (!item || !input) return
      if (!input.ct || !input.dia) {
        this.$message.warning('请先填写中心厚度和直径')
        return
      }
      const qty = parseInt(input.qty) || 1
      const copy = Object.assign({}, item)
      copy['中心厚度'] = input.ct
      copy['直径'] = input.dia
      copy['number'] = qty
      this.doPrint([copy])
    },
    doPrint(data) {
      this.printdata = data || []
      this.isprint = true
      const self = this
      this.$nextTick(() => {
        self.renderCodes()
        self.$print(self.$refs.printArea)
        self.isprint = false
      })
    },
    renderCodes() {
      const self = this
      this.printdata.forEach((item, idx) => {
        const pageCount = self.getPageCount(item)
        for (let page = 1; page <= pageCount; page++) {
          const components = self.getComponents(item)
          components.forEach(comp => {
            if (comp.type === 'barcode') {
              const refKey = 'barcode_' + idx + '_' + page + '_' + comp.id
              const el = self.$refs[refKey]
              if (el && el.length) {
                try {
                  const value = comp.fieldName ? self.getFieldValue(comp.fieldName, item) : (comp.content || '')
                  const compW = self.mmToPx(comp.width)
                  const compH = self.mmToPx(comp.height)
                  JsBarcode(el[0], value || ' ', {
                    format: 'CODE128',
                    width: 2,
                    height: compH,
                    displayValue: true,
                    fontSize: Math.max(8, (comp.fontSize || 10)),
                    margin: 0
                  })
                  const svg = el[0]
                  const natW = parseFloat(svg.getAttribute('width')) || compW
                  const natH = parseFloat(svg.getAttribute('height')) || compH
                  svg.setAttribute('viewBox', '0 0 ' + natW + ' ' + natH)
                  svg.setAttribute('width', compW)
                  svg.setAttribute('height', compH)
                  svg.setAttribute('preserveAspectRatio', 'none')
                  svg.style.width = compW + 'px'
                  svg.style.height = compH + 'px'
                } catch (e) { /* ignore */ }
              }
            }
          })
        }
      })
    },
    getPageCount(item) {
      const number = item.number || item['数量'] || 1
      return Math.max(1, Math.ceil(parseFloat(number)))
    },
    getComponents(item) {
      const tpl = item.template
      if (tpl && tpl.templateContent && tpl.templateContent.components) {
        return tpl.templateContent.components
      }
      return []
    },
    mmToPx(mm) {
      return Math.round(mm * 96 / 25.4)
    },
    pageStyle(item) {
      const tpl = item.template
      return {
        width: this.mmToPx(tpl ? tpl.widthMm : 75) + 'px',
        height: this.mmToPx(tpl ? tpl.heightMm : 40) + 'px',
        pageBreakAfter: 'always'
      }
    },
    getCompStyle(comp, item) {
      let transform = ''
      if (comp.rotation === 180) {
        transform = 'rotate(180deg)'
      }
      const vMap = { top: 'flex-start', center: 'center', bottom: 'flex-end' }
      const hMap = { left: 'flex-start', center: 'center', right: 'flex-end' }
      const style = {
        position: 'absolute',
        left: this.mmToPx(comp.x) + 'px',
        top: this.mmToPx(comp.y) + 'px',
        width: this.mmToPx(comp.width) + 'px',
        height: this.mmToPx(comp.height) + 'px',
        transform: transform,
        display: 'flex',
        alignItems: vMap[comp.verticalPos] || 'center',
        justifyContent: hMap[comp.align] || 'flex-start',
        overflow: 'hidden'
      }
      const tplContent = item.template && item.template.templateContent
      const effFF = comp.fontFamily != null ? comp.fontFamily : (tplContent && tplContent.defaultFontFamily)
      const effBold = comp.bold != null ? comp.bold : (tplContent && tplContent.defaultBold)
      if (effFF) style.fontFamily = effFF
      if (effBold) style.fontWeight = 'bold'
      return style
    },
    getFontSizePx(comp, item) {
      const tpl = item.template
      return comp.fontSize || (tpl ? tpl.defaultFontSize : 10) || 10
    },
    getFieldValue(fieldName, item) {
      if (!fieldName) return ''
      const val = item[fieldName]
      return val !== undefined && val !== null ? val : ''
    },
    getImageUrl(comp, item) {
      if (comp.fieldName) {
        const v = this.getFieldValue(comp.fieldName, item)
        if (v) return v
      }
      return comp.content || ''
    },
    getQrCodeSrc(comp, item) {
      if (comp.fieldName) {
        // 后台将二维码图片 base64 存在「字段名+图片」里（防伪码地址 → 防伪码图片）
        const imgKey = comp.fieldName.replace(/地址$/, '图片')
        const imgVal = item[imgKey]
        if (imgVal) return imgVal
        const v = this.getFieldValue(comp.fieldName, item)
        if (v) return v
      }
      return ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/testorder/cstagreement/LensLabelPrint.vue